import React, { useState, useEffect, useRef, useContext } from "react";
import lottie from "lottie-web";
import MyContext from "../../../../context/MyContext";
import Lottie from "lottie-web";
import TickerContext from "../../../../context/ticker";
import AuthContext from "../../../../context/userAuth.context";
import Swal from "sweetalert2";

const PropsLoader = (props) => {
  const { setBackgrounds } = useContext(MyContext);

  const Animation = useRef(null);
  const BackgroundAnimation = useRef(null);

  const [delayHandler, setDelayHandler] = useState(null);

  const {
    timelineZoomVal,
    setLayersData,
    LayersData,
    calculateTimeByWidth,
    clone,
    setRedoLayer,
    UndoLayer,
    setUndoLayer,
    calculateWidthByDuration,
    Tl_TotalTime,
    ChangeCount,
    setChangeCount,
    seteditableObject,
    EditorZoom,
    Call_ScreenShot,
    setCall_ScreenShot,
  } = useContext(MyContext);

  const { Goto, setGoto, TickerPosition } = useContext(TickerContext);

  const [state, setstate] = useState(false);

  const [PropData, setPropData] = useState(null);

  const { authenticationData, Access, getLink } = useContext(AuthContext);

  const playAnim = () => {
    setDelayHandler(
      setTimeout(() => {
        let ctx = null;
        if (props.name === "Animated Backgrounds") {
          if (
            BackgroundAnimation.current == null ||
            BackgroundAnimation.current == undefined
          )
            return;
          ctx = BackgroundAnimation.current.getContext("2d");
        } else ctx = Animation.current.getContext("2d");

        const get = lottie.loadAnimation({
          name: props.Item_Path,
          renderer: "canvas",
          loop: true,
          autoplay: true,
          path: authenticationData.ApiBaseURL + "/" + props.Item_Path,
          rendererSettings: {
            context: ctx,
            clearCanvas: true,
            preserveAspectRatio: "xMidYMid meet",
          },
        });
        setPropData(get);
        setstate(true);
      }, 500)
    );
  };

  const stopAnim = () => {
    setstate(false);
    clearTimeout(delayHandler);
    if (PropData != null) {
      Lottie.destroy(props.Item_Path);
      setPropData(null);
    }
  };

  const AddProp = () => {
    var stack = [...UndoLayer];
    var PrevArray;
    if (LayersData.length != 0) {
      PrevArray = clone(LayersData);
    } else {
      PrevArray = [];
    }

    if (stack.length < 10) {
      stack.push(PrevArray);
      setUndoLayer(stack);
      setRedoLayer([]);
    } else {
      stack.shift();
      stack.push(PrevArray);
      setUndoLayer(stack);
      setRedoLayer([]);
    }

    if (PropData != null) {
      let calc = PropData.animationData.h / PropData.animationData.w;
      if (PropData.animationData.w > 5 && PropData.animationData.h > 5)
        Start(calc, PropData.animationData.h, PropData.animationData.w);
    } else {
      const ctx = Animation.current.getContext("2d");

      const get = lottie.loadAnimation({
        name: props.Item_Path,
        renderer: "canvas",
        loop: 1,
        autoplay: true,
        path: authenticationData.ApiBaseURL + "/" + props.Item_Path,
        rendererSettings: {
          context: ctx,
          clearCanvas: true,
          preserveAspectRatio: "xMidYMid meet",
        },
      });
      get.addEventListener("enterFrame", function () {
        let calc = get.animationData.h / get.animationData.w;
        setPropData(get);

        Start(calc, get.animationData.h, get.animationData.w);
        get.removeEventListener("enterFrame");
      });
    }
  };

  const AddAnimatedBackground = () => {
    // if(!Call_ScreenShot)
    // {
    //   setCall_ScreenShot(true)
    // }
    if (Access === "FE") {
      Swal.fire({
        title: "Upgrade Required",
        html:
    `You have not purchased this upgrade yet. Please <a href=${getLink()} target='_blank'>upgrade</a> to unlock all features.`,
        icon: "info",
        cancelButtonColor: "#d33",
        backdrop: null,
      });
      return;
    }
    const ctx = BackgroundAnimation.current.getContext("2d");
    var animationPath = authenticationData.ApiBaseURL + "/" + props.Item_Path;
    const get = lottie.loadAnimation({
      name: props.Item_Path,
      renderer: "canvas",
      loop: true,
      autoplay: true,
      path: animationPath,
      rendererSettings: {
        context: ctx,
        clearCanvas: true,
        preserveAspectRatio: "xMidYMid meet",
      },
    });
    get.addEventListener("enterFrame", function () {
      let calc = get.animationData.h / get.animationData.w;
      //setPropData(get)

      Start(calc);
      get.removeEventListener("enterFrame");
    });
    setBackgrounds({
      type: "Animated",
      color: null,
      Path: props.ImgPath,
      AnimationPath: props.Item_Path,
      gradient: { Gcolor: null, FirstColor: null, SecondColor: null },
    });
  };

  function makeid(length) {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  function getRandomArbitrary(min, max) {
    return parseInt(Math.random() * (max - min) + min);
  }

  const Start = (calc, animationHeight, animationWidth) => {
    var canvasHeight =
      document.getElementsByClassName("EditorTrackInner")[0].offsetHeight;
    var CanvasWidth =
      document.getElementsByClassName("EditorTrackInner")[0].offsetWidth;
    let halfCanvas = CanvasWidth / 2 + EditorZoom;
    let ratio = (CanvasWidth - halfCanvas) / animationWidth;
    let _widthPercentage = 300 / animationWidth;
    let _heightPercentage = 300 / animationHeight;
    let _width = animationWidth * ratio;
    let _height = animationHeight * ratio;
    var top = 0;
    var left = 0;

    if (props.name === "Animated Backgrounds") {
      _width = CanvasWidth;
      _height = canvasHeight;
      top = 0;
      left = 0;
    }

    if (Goto.innerMenu == "prop") {
      const array = Array.from(LayersData);
      for (var i = 0; i < array.length; i++) {
        if (array[i].key === Goto.key) {
          Lottie.destroy(array[i].Name);
          array[i].PropImage = props.ImgPath;
          array[i].AnimationPath = props.Item_Path;
          array[i].width = 150 * calc;
        }
      }
      setLayersData(array);
      setChangeCount(ChangeCount + 1);
      setGoto({
        menu: null,
        innerMenu: null,
        key: null,
      });
    } else {
      var topIndex = 0;
      if (LayersData.length > 0) {
        topIndex = LayersData[LayersData.length - 1].layerIndex;
        topIndex = topIndex + 1;
      }
      var typelength = 1;
      var checkKey = 0;
      for (var i = 0; i < LayersData.length; i++) {
        if (LayersData[i].Editable === true) {
          LayersData[i].Editable = false;
          LayersData[i].showDiv = false;
        }
        LayersData[i].toolbar = false;

        if (LayersData[i].type === "Props") {
          typelength = typelength + 1;
        }
        if (LayersData[i].key >= checkKey) {
          checkKey = LayersData[i].key;
        }
      }
      // let TickPos
      // let trans = document.getElementById('tickerHead').style.transform
      // if (trans != "") {
      //     trans = trans.split('(')
      //     trans = trans[1].split(',')
      //     trans = trans[0].split('px')
      //     trans = eval(trans[0]);
      //     TickPos = trans
      // }

      let currentTime = calculateTimeByWidth(TickerPosition);
      let totalTime = calculateTimeByWidth(Tl_TotalTime.width - TickerPosition);
      let type = "Props";
      //let Subtype = "AnimatedBackground";
      if (props.name != "Animated Backgrounds") {
        let newEntryLayerData = {
          Added: true,
          key: checkKey + 1,
          AnimationId: makeid(5),
          type: type,
          Subtype: "",
          bgColor: "#8e5fff",
          EditorZoom: EditorZoom,
          Name: `Props-${typelength}`,
          AnimationPath: props.Item_Path,
          PropImage: props.ImgPath,
          canvas: null,
          TimelineZoom: timelineZoomVal,
          layerIndex: topIndex,
          index: null,
          duration: totalTime,
          startTime: currentTime,
          endTime: calculateTimeByWidth(Tl_TotalTime.width),
          visible: true,
          OutEffect: "none",
          InEffect: "none",
          typeIcon: "vrpano",
          startTransitionWidth: 0,
          startTransitionLeft: 0,
          endTransitionWidth: 0,
          endTransitionLeft: 0,
          angle: 0,
          lock: false,
          x: left,
          y: top,
          flip: "scaleX(1)",
          width: _width,
          height: _height,
          toolbar: true,
          FurtherSetting: false,
          opacity: 1,
          originalOpacity: 1,
          layerlock: false,
          opc: 1,
          hidden: false,
          Editable: true,
          startPositionOnTimeline: TickerPosition,
          player: false,
          InMultiDrag: false,
          rotateAngle: 0,
          showDiv: true,
          JSONValue: (async () => {
            const resp = await fetch(
              authenticationData.ApiBaseURL + "/" + props.Item_Path
            );
            const jsonData = await resp.json();
            newEntryLayerData.JSONValue = jsonData;
            newEntryLayerData.widthOnTimeline = calculateWidthByDuration(
              newEntryLayerData.duration
            );
            newEntryLayerData.endTransitionLeft =
              newEntryLayerData.widthOnTimeline -
              newEntryLayerData.endTransitionWidth;
            setLayersData(LayersData.concat(newEntryLayerData));
            seteditableObject({
              showPanel: true,
              editableItem: newEntryLayerData,
            });
            setChangeCount(ChangeCount + 1);
            return jsonData;
          })(),
        };
        // newEntryLayerData.widthOnTimeline = calculateWidthByDuration(
        //   newEntryLayerData.duration
        // );
        // debugger
        // newEntryLayerData.endTransitionLeft =
        //   newEntryLayerData.widthOnTimeline -
        //   newEntryLayerData.endTransitionWidth;
        // setLayersData(LayersData.concat(newEntryLayerData));
      }
    }
  };

  const setAnimatedBackground = () => {
    //setBackgrounds({ type: 'image', color: null, Path: data, gradient: { Gcolor: null, FirstColor: null, SecondColor: null } })
  };

  return props.name != "Animated Backgrounds" ? (
    <div
      className={"Props_items_start "}
      onMouseEnter={playAnim}
      onClick={() =>
        AddProp(authenticationData.ApiBaseURL + "/" + props.Item_Path)
      }
      onMouseLeave={stopAnim}
    >
      <img
        src={authenticationData.ApiBaseURL + "/" + props.ImgPath}
        style={{
          display: state == true ? "none" : "block",
          width: "100%",
          height: "100%",
        }}
      />
      <canvas
        ref={Animation}
        id={"props-" + props.Item_Path}
        width={90}
        height={100}
        style={{
          width: "100%",
          height: "100%",
          display: state == true ? "block" : "none",
        }}
      ></canvas>
    </div>
  ) : (
    <div
      className={"AnimatedBackgorund_items_start "}
      onMouseEnter={playAnim}
      onClick={AddAnimatedBackground}
      onMouseLeave={stopAnim}
      style={{ position: "relative" }}
    >
      {Access === "FE" && (
        <img
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            width: "20px",
            height: "20px",
            zIndex: "1",
          }}
          src="../AppIcons/IconsAll/PremiumIcon.svg"
          alt=""
        />
      )}
      <img
        src={authenticationData.ApiBaseURL + "/" + props.ImgPath}
        style={{
          display: state == true ? "none" : "block",
          width: "100%",
          height: "100%",
        }}
      />
      <canvas
        ref={BackgroundAnimation}
        width={480}
        height={270}
        style={{
          width: "100%",
          height: "100%",
          display: state == true ? "block" : "none",
        }}
      ></canvas>
    </div>
  );
};

export default PropsLoader;
